const state = {
  drawerComponent: "homeDrawer",
  navComponent: "navDrawer", // 动态导航
  leftComponent: "leftDrawer",
  rightComponent: "rightDrawer",
  rightComponentBak: "rightDrawer", // 当前页面的默认右侧模板名称
  xjCompentent: "lansheDrawer",
  videoList: {},
  photoShow: null,
  graphic: {},
  qxzInfo: {},
  // breedCompentent: "yzCompentent",
  breedCompentent: "sjscCompentent",
  oldCompentent: "",
  rightMx: "",
  mxContent: "",
  equipId: null,
  equipItem: {},
  imgShow: null,
  imgArr: null,
  leftDs: "",
  rightDs: "",
  seleIndex: 0, //首页的导航选中
  fromPath: "home"
};

const mutations = {
  SET_DRAWER_COMPONENT: (state, drawer) => {
    state.drawer = drawer;
  },
  SET_NAV_COMPONENT: (state, component) => {
    state.navComponent = component;
  },
  SET_LEFT_COMPONENT: (state, component) => {
    state.leftComponent = component;
  },
  SET_RIGHT_COMPONENT: (state, component) => {
    state.rightComponent = component;
  },
  SET_RIGHT_COMPONENT_BAK: (state, component) => {
    state.rightComponentBak = component;
  },
  SET_XJ_COMPONENT: (state, component) => {
    state.xjCompentent = component;
  },
  SET_VIDEO_LIST: (state, videoList) => {
    state.videoList = videoList;
  },
  SET_GRAPHIC: (state, graphic) => {
    state.graphic = graphic;
  },
  SET_PHOTO_SHOW: (state, videoList) => {
    state.photoShow = videoList;
  },
  SET_QXZ_INFO: (state, qxzInfo) => {
    state.qxzInfo = qxzInfo;
  },
  SET_BREED_COMPONENT: (state, breedCompentent) => {
    state.breedCompentent = breedCompentent;
  },
  SET_OLD_COMPONENT: (state, oldCompentent) => {
    state.oldCompentent = oldCompentent;
  },
  SET_RIGHT_MX: (state, rightMx) => {
    state.rightMx = rightMx;
  },
  SET_MX_CONTENT: (state, mxContent) => {
    state.mxContent = mxContent;
  },
  SET_EQUIP_ID: (state, equipId) => {
    state.equipId = equipId;
  },
  SET_EQUIP_ITEM: (state, equipItem) => {
    state.equipItem = equipItem;
  },
  SET_IMG_SHOW: (state, imgShow) => {
    state.imgShow = imgShow;
  },
  SET_IMG_ARR: (state, imgShow) => {
    state.imgArr = imgShow;
  },
  SET_SELE_INDEX: (state, v) => {
    state.seleIndex = v;
  },
  SET_FROM_PATH: (state, v) => {
    state.fromPath = v;
  }
};

const actions = {
  setDrawerComponent({ commit }, drawer) {
    commit("SET_DRAWER_COMPONENT", drawer);
  },
  setNavComponent({ commit }, drawer) {
    commit("SET_NAV_COMPONENT", drawer);
  },
  setLeftComponent({ commit }, component) {
    commit("SET_LEFT_COMPONENT", component);
  },
  setRightComponent({ commit }, component) {
    commit("SET_RIGHT_COMPONENT", component);
  },
  setRightComponentBak({ commit }, component) {
    commit("SET_RIGHT_COMPONENT_BAK", component);
  },
  setXjComponent({ commit }, component) {
    commit("SET_XJ_COMPONENT", component);
  },
  setBreedComponent({ commit }, component) {
    commit("SET_BREED_COMPONENT", component);
  },
  setOldComponent({ commit }, component) {
    commit("SET_OLD_COMPONENT", component);
  },
  setVideoList({ commit }, videoList) {
    commit("SET_VIDEO_LIST", videoList);
  },
  setPhotoShow({ commit }, videoList) {
    commit("SET_PHOTO_SHOW", videoList);
  },
  setGraphic({ commit }, graphic) {
    commit("SET_GRAPHIC", graphic);
  },
  setQxzInfo({ commit }, qxzInfo) {
    commit("SET_QXZ_INFO", qxzInfo);
  },
  setRightMx({ commit }, rightMx) {
    commit("SET_RIGHT_MX", rightMx);
  },
  setmxContent({ commit }, mx) {
    commit("SET_MX_CONTENT", mx);
  },
  setEquipId({ commit }, equipId) {
    commit("SET_EQUIP_ID", equipId);
  },
  setEquipItem({ commit }, equipItem) {
    commit("SET_EQUIP_ITEM", equipItem);
  },
  setImgShow({ commit }, component) {
    commit("SET_IMG_SHOW", component);
  },
  setImgArr({ commit }, component) {
    commit("SET_IMG_ARR", component);
  },
  setSeleIndex({ commit }, v) {
    commit("SET_SELE_INDEX", v);
  },
  setFromPath({ commit }, v) {
    commit("SET_FROM_PATH", v);
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
